import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';

const ActionButtons = ({ actions }) => {
    //Tomo los props
    //Render
    return (
        <ButtonGroup className="mb-2 mb-md-0">
            {
                actions.filter(a => a.visible).map((action, index) => (
                    <Button key={index} size="sm" variant={action.type} onClick={action.handle}>
                        {
                            action.icon ? (
                                <FontAwesomeIcon 
                                    icon={action.icon}
                                    className="mr-1"
                                />
                            ) : null
                        }
                        <br className="d-md-none" />
                        <strong>{ action.title.toUpperCase() }</strong>
                    </Button>
                ))
            }
            
        </ButtonGroup>
    );
};

export default ActionButtons;